import { IAnalyticsState } from '../../types/analytics';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

export const INITIAL_STATE: IAnalyticsState = {
  page: {
    pageType: 'Newbuilding_Finder_Form',
    siteType: 'desktop',
  },
};

export const analyticsReducer = createNoopReducer<IAnalyticsState>(INITIAL_STATE);
